import React, { FC } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  color: ${({ theme }) => theme.maxButtonColor};
  background-color: ${({ theme }) => theme.maxButtonBackgroundColor};
  border: 1px solid ${({ theme }) => theme.maxButtonBorderColor};
  border-radius: 12px;
  padding: 5px;
  font-size: 13px;
  margin-left: 5px;

  &:hover {
    cursor: pointer;
    transition: background-color 200ms linear;
    opacity: 0.8;
  }
`

interface HasString {
  toString: () => string
}

export interface Props<T extends HasString> {
  onClick: (t: T) => void
  value: T
  text?: string
}

export const StepButton = <T extends HasString>({
  onClick,
  value,
  text,
}: Props<T>): JSX.Element => {
  return (
    <Wrapper
      onClick={() => {
        onClick(value)
      }}
    >
      {text ? text : value.toString()}
    </Wrapper>
  )
}
